import { render, staticRenderFns } from "./NestedCategoryItem.vue?vue&type=template&id=c42fc86e"
import script from "./NestedCategoryItem.vue?vue&type=script&lang=js"
export * from "./NestedCategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports